export const translations = {
    hu: {
        title: "Asztalfoglalás",
        step1: "Dátum",
        step2: "Részletek",
        step3: "Megerősítés",
        step1Title: "1. Válassz napot",
        step2Title: "2. Add meg az adatokat",
        date: "Dátum",
        name: "Név",
        headcount: "Létszám (fő)",
        phone: "Telefonszám",
        phonePlaceholder: "Pl.: 06 30 123 4567",
        email: "E-mail cím",
        startTime: "Kezdés",
        endTime: "Befejezés",
        endTimeHelper: "Nem kötelező megadni. Ha üresen hagyod, automatikusan a kezdéstől számított 2 órával számolunk.",
        preferredTimeSlotLabel: "Preferált idősáv",
        seatingPreferenceLabel: "Ülés preferencia",
        seatingPreferenceAny: "Bármi",
        seatingPreferenceBar: "Bár",
        seatingPreferenceTable: "Asztal",
        seatingPreferenceOutdoor: "Terasz",
        preferenceNotProvided: "Nincs megadva",
        occasion: "Alkalom",
        back: "Vissza",
        next: "Tovább",
        submitting: "Küldés...",
        errorRequired: "Ez a mező kötelező.",
        errorNameRequired: "Add meg a neved, hogy az étterem azonosítani tudja a foglalást.",
        errorPhoneRequired: "Adj meg egy elérhető telefonszámot.",
        errorEmailRequired: "Add meg az e-mail címed, hogy elküldhessük a foglalás részleteit.",
        errorHeadcountRequired: "Add meg, hány főre szeretnél foglalni.",
        errorStartTimeRequired: "Válaszd ki, mikor kezdődjön a foglalás.",
        errorCustomSelectRequired: "Válassz egy értéket ehhez: {label}.",
        errorInvalidPhone: "Adj meg egy érvényes, elérhető telefonszámot.",
        errorInvalidEmail: "Adj meg egy érvényes e-mail címet.",
        errorTime: "A befejezésnek későbbinek kell lennie, mint a kezdés.",
        errorTimeWindow: "A foglalás teljes időtartamának {start} és {end} közé kell esnie.",
        errorCapacityFull: "Erre a napra az egység már elérte a maximális kapacitást.",
        errorCapacityLimited: "Erre a napra már csak {count} főre foglalhatsz.",
        errorDailyLimitReached: "Erre a napra elfogyott a foglalási kapacitás.",
        genericError: "Hiba történt. Kérjük, próbálja meg később.",
        kitchenHours: "Konyha nyitvatartás",
        barHours: "Bár nyitvatartás",
        serviceOpeningInfo: "Nyitvatartási információk",
        bookableWindowLabel: "Foglalási időablak",
        bookableWindowHint: "A foglalás teljes időtartamának bele kell férnie ebbe az időablakba.",
        untilClose: "Zárásig",
        reservationModeLabel: "Foglalás módja",
        reservationModeAuto: "Automatikus megerősítés",
        reservationModeRequest: "Foglalási kérelem (admin jóváhagyással)",
        step3Title: "Foglalási kérés elküldve!",
        step3Body: "Köszönjük! Hamarosan felvesszük Önnel a kapcsolatot a megadott elérhetőségeken a foglalás megerősítésével kapcsolatban.",
        step3TitleConfirmed: "Foglalás megerősítve!",
        step3BodyConfirmed: "Köszönjük a foglalást! Asztalát sikeresen lefoglaltuk a megadott időpontra.",
        step3Details: "A foglalás részletei",
        newBooking: "Új foglalás",
        referenceCode: "Foglalási azonosító",
        addToCalendar: "Hozzáadás a naptárhoz",
        googleCalendar: "Google Calendar",
        otherCalendar: "Másik naptár (.ics)",
        manageLinkTitle: "Foglalás kezelése",
        manageLinkBody: "A foglalásod részleteit megtekintheted vagy lemondhatod a lenti, egyedi link segítségével. Mentsd el a linket a későbbi hozzáféréshez.",
        copy: "Másolás",
        copied: "Másolva!",
        emailConfirmationSent: "A megerősítő e-mailt elküldtük a megadott címre.",
        dayNames: ['H', 'K', 'Sze', 'Cs', 'P', 'Szo', 'V'],
        monthNames: ["Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"],

        // Manage Page
        manageTitle: "Foglalás kezelése",
        reservationDetails: "Foglalás részletei",
        status: "Státusz",
        status_pending: "Függőben",
        status_confirmed: "Megerősítve",
        status_cancelled: "Lemondva",
        status_completed: "Teljesítve",
        cancelReservation: "Foglalás lemondása",
        modifyReservation: "Foglalás módosítása",
        modifySectionTitle: "Módosítás",
        modifyRequestSectionTitle: "Módosítás kérése",
        modifySectionHint: "Frissítsd a létszámot és az időpontot a foglaláshoz.",
        modifyRequestHint: "Az eredeti foglalás változatlan marad, amíg az admin jóvá nem hagyja a módosítási kérést. Az admin elfogadhatja vagy elutasíthatja a kérést.",
        modifySave: "Mentés",
        modifyRequestSave: "Módosítási kérés küldése",
        modifySaving: "Mentés...",
        modifySuccess: "A foglalás módosítása sikeres.",
        modifyRequestSuccess: "A módosítási kérés elküldve. Az eredeti foglalás változatlan marad az admin döntéséig.",
        modifyRequestRequiresPolicy: "Kérjük válaszd ki, mi történjen az eredeti foglalással, ha az admin elutasítja a módosítást.",
        pendingGuestModificationExists: "Már van függő módosítási kérés.",
        pendingGuestModificationTitle: "Függő módosítási kérés",
        pendingGuestModificationOriginal: "Eredeti",
        pendingGuestModificationProposed: "Kért módosítás",
        rejectionPolicyLabel: "Ha az admin elutasítja",
        rejectionPolicyKeepOriginal: "Eredeti foglalás megtartása",
        rejectionPolicyCancelOriginal: "Eredeti foglalás lemondása",
        modifyLocked: "Csak olvasható",
        modifyMissingTime: "Kérjük add meg a kezdés és befejezés időpontját.",
        modifyInvalidHeadcount: "Érvénytelen létszám.",
        modifyHeadcountRange: "A létszám {min}-{max} között lehet.",
        modifyHeadcountHint: "Megengedett létszám: {min}-{max} fő.",
        cancelReservationHint: "Ha lemondod, a foglalás végleg törlődik.",
        areYouSureCancel: "Biztosan le szeretnéd mondani a foglalást?",
        cancelConfirmationBody: "Ez a művelet nem vonható vissza.",
        cancelReasonLabel: "Lemondás oka",
        cancelReasonPlaceholder: "Opcionális megjegyzés...",
        yesCancel: "Igen, lemondom",
        noKeep: "Nem, megtartom",
        cancelling: "Lemondás...",
        reservationCancelledSuccess: "A foglalás sikeresen lemondva.",
        backToHome: "Vissza a főoldalra",
        pendingApproval: "Ez a foglalás jóváhagyásra vár.",
        pendingApprovalHint: "A megerősítésig a vendég nem kap végleges visszaigazolást.",
        guestActionsLabel: "Vendég műveletek",
        adminActionsLabel: "Admin műveletek",
        adminActionTitle: "E-mailből érkező jóváhagyás", 
        adminApprove: "Elfogadás",
        adminReject: "Elutasítás",
        invalidAdminToken: "A jóváhagyó hivatkozás érvénytelen vagy már felhasznált.",
        expiredAdminToken: "A jóváhagyó hivatkozás lejárt.",
        adminActionNotPending: "Ez a foglalás már nem vár jóváhagyásra.",
        invalidManageLink: "A foglalási link érvénytelen. Ellenőrizd, hogy a teljes linket nyitottad-e meg.",
        expiredManageLink: "A foglalási link lejárt. Régi linkkel ez a foglalás már nem kezelhető online.",
        reservationApproved: "Foglalás elfogadva.",
        reservationRejected: "Foglalás elutasítva.",
        modificationRequestApproved: "Módosítási kérés jóváhagyva.",
        modificationRequestRejected: "Módosítási kérés elutasítva.",
        actionFailed: "A művelet nem sikerült, kérjük próbáld meg újra.",
        cancelFailed: "Hiba a lemondás során.",
        modifyNextSteps: "Hamarosan visszaigazolást küldünk a frissített foglalásról.",
        cancelNextSteps: "A lemondásról visszaigazolást küldünk a megadott elérhetőségekre.",
        cancelledByLabel: "Lemondta",
        cancelledBy_guest: "Vendég",
        cancelledBy_admin: "Admin",
        cancelledBy_system: "Rendszer",
        cancelledBy_guest_label: "Lemondva vendég által",
        cancelledBy_admin_label: "Lemondva admin által",
        cancelledBy_system_label: "Lemondva rendszer által",
        guestModificationRejectedCancelOriginalReason: "A vendég előzetes választása alapján lemondva, mert a módosítási kérés elutasításra került.",
        decisionApprovedLabel: "Elfogadva",
        decisionRejectedLabel: "Elutasítva",
    },
    en: {
        title: "Table Reservation",
        step1: "Date",
        step2: "Details",
        step3: "Confirmation",
        step1Title: "1. Select a date",
        step2Title: "2. Enter your details",
        date: "Date",
        name: "Name",
        headcount: "Number of guests",
        phone: "Phone number",
        phonePlaceholder: "E.g.: 07700 900123",
        email: "Email address",
        startTime: "Start time",
        endTime: "End time",
        endTimeHelper: "Optional. If left empty, we will automatically calculate 2 hours from the start time.",
        preferredTimeSlotLabel: "Preferred time slot",
        seatingPreferenceLabel: "Seating preference",
        seatingPreferenceAny: "Any",
        seatingPreferenceBar: "Bar",
        seatingPreferenceTable: "Table",
        seatingPreferenceOutdoor: "Outdoor",
        preferenceNotProvided: "Not provided",
        occasion: "Occasion",
        back: "Back",
        next: "Next",
        submitting: "Submitting...",
        errorRequired: "This field is required.",
        errorNameRequired: "Enter your name so the restaurant can identify your reservation.",
        errorPhoneRequired: "Enter a reachable phone number.",
        errorEmailRequired: "Enter your email address so we can send your reservation details.",
        errorHeadcountRequired: "Enter how many guests the reservation is for.",
        errorStartTimeRequired: "Select when the reservation should start.",
        errorCustomSelectRequired: "Select an option for {label}.",
        errorInvalidPhone: "Enter a valid, reachable phone number.",
        errorInvalidEmail: "Enter a valid email address.",
        errorTime: "The end time must be after the start time.",
        errorTimeWindow: "The full reservation duration must fit between {start} and {end}.",
        errorCapacityFull: "This unit is fully booked for this date.",
        errorCapacityLimited: "There is only space for {count} more guests on this date.",
        errorDailyLimitReached: "Reservation capacity is full for this date.",
        genericError: "An error occurred. Please try again later.",
        kitchenHours: "Kitchen hours",
        barHours: "Bar hours",
        serviceOpeningInfo: "Opening information",
        bookableWindowLabel: "Booking window",
        bookableWindowHint: "The full reservation duration must fit within this booking window.",
        untilClose: "Until closing",
        reservationModeLabel: "Reservation mode",
        reservationModeAuto: "Automatic confirmation",
        reservationModeRequest: "Reservation request (requires admin approval)",
        step3Title: "Reservation request sent!",
        step3Body: "Thank you! We will contact you shortly at the provided contact details to confirm your reservation.",
        step3TitleConfirmed: "Reservation Confirmed!",
        step3BodyConfirmed: "Thank you for your reservation! Your table has been successfully booked for the selected time.",
        step3Details: "Your reservation details",
        newBooking: "New Reservation",
        referenceCode: "Reservation ID",
        addToCalendar: "Add to Calendar",
        googleCalendar: "Google Calendar",
        otherCalendar: "Other Calendar (.ics)",
        manageLinkTitle: "Manage your reservation",
        manageLinkBody: "You can view the details of your reservation or cancel it using the unique link below. Please save it for future access.",
        copy: "Copy",
        copied: "Copied!",
        emailConfirmationSent: "A confirmation email has been sent to the provided address.",
        dayNames: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        
        // Manage Page
        manageTitle: "Manage Reservation",
        reservationDetails: "Reservation Details",
        status: "Status",
        status_pending: "Pending",
        status_confirmed: "Confirmed",
        status_cancelled: "Cancelled",
        status_completed: "Completed",
        cancelReservation: "Cancel Reservation",
        modifyReservation: "Modify Reservation",
        modifySectionTitle: "Modify Reservation",
        modifySectionHint: "Update the party size and time for your booking.",
        modifySave: "Save changes",
        modifySaving: "Saving...",
        modifySuccess: "Reservation updated successfully.",
        modifyLocked: "Read-only",
        modifyMissingTime: "Please enter both the start and end time.",
        modifyInvalidHeadcount: "Invalid headcount.",
        modifyHeadcountRange: "Headcount must be between {min}-{max}.",
        modifyHeadcountHint: "Allowed party size: {min}-{max} guests.",
        cancelReservationHint: "Cancelling will permanently remove the reservation.",
        areYouSureCancel: "Are you sure you want to cancel this reservation?",
        cancelConfirmationBody: "This action cannot be undone.",
        cancelReasonLabel: "Cancellation reason",
        cancelReasonPlaceholder: "Optional note...",
        yesCancel: "Yes, Cancel",
        noKeep: "No, Keep it",
        cancelling: "Cancelling...",
        reservationCancelledSuccess: "Your reservation has been successfully cancelled.",
        backToHome: "Back to Home",
        pendingApproval: "This reservation is awaiting approval.",
        pendingApprovalHint: "The guest will not receive a final confirmation until it is approved.",
        guestActionsLabel: "Guest actions",
        adminActionsLabel: "Admin actions",
        adminActionTitle: "Approve or reject from email",
        adminApprove: "Approve",
        adminReject: "Reject",
        invalidAdminToken: "The approval link is invalid or already used.",
        expiredAdminToken: "The approval link has expired.",
        adminActionNotPending: "This reservation is no longer pending approval.",
        invalidManageLink: "The reservation link is invalid. Check that you opened the complete link.",
        expiredManageLink: "The reservation link has expired. This booking can no longer be managed online with this old link.",
        reservationApproved: "The reservation has been approved and confirmed.",
        reservationRejected: "The reservation has been rejected.",
        actionFailed: "The action failed, please try again.",
        cancelFailed: "Failed to cancel the reservation.",
        modifyNextSteps: "We will send a confirmation for the updated reservation shortly.",
        cancelNextSteps: "We will send a cancellation confirmation to your contact details.",
        cancelledByLabel: "Cancelled by",
        cancelledBy_guest: "Guest",
        cancelledBy_admin: "Admin",
        cancelledBy_system: "System",
        cancelledBy_guest_label: "Cancelled by guest",
        cancelledBy_admin_label: "Cancelled by admin",
        cancelledBy_system_label: "Cancelled by system",
        guestModificationRejectedCancelOriginalReason: "Cancelled based on the guest’s prior choice because the modification request was rejected.",
        decisionApprovedLabel: "Approved",
        decisionRejectedLabel: "Rejected",
    },
};
